import { axiosInstance } from "../../Interceptor";
import { DEL_MON_REQ, GET_MON_REQ, SAVE_MON_REQ, STUD_PROFILE } from "../../management/utils/const";

export const fetchMyStudentProfile = (username) => {
    return {
      type: STUD_PROFILE,
      payload: axiosInstance.get(`/stud/manage/myprofile/${username}`),
    };
  };
